/* global axios */
import ApiClient from '../ApiClient';

class CaptainLlmCredential extends ApiClient {
  constructor() {
    super('captain/llm_credential', { accountScoped: true });
  }

  test() {
    return axios.post(`${this.url}/test`);
  }
}

export default new CaptainLlmCredential();
